import axios from "axios";
import { toast } from "react-toastify";
import { BASEURL } from "../constants";

export function removeDecimalIfZero(inputString) {
  if (inputString.endsWith(".00")) {
    return inputString.slice(0, -3); // Remove the last 3 characters (".00")
  } else {
    return inputString; // No change needed
  }
}

export function formatCurrencySign(number) {
  // Use toFixed(2) to round the number to two decimal places
  // Use replace to add commas for thousands
  return "$" + number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const sendOtp = async (studentId, ObjectType = 5) => {
    try {
      const response = await axios.post(`${BASEURL}Login/sendOtp`, {
        StudentId: studentId,
        ObjectType: "5", // 5 = Student
      });

      if (response.data.success) {
        toast.success("OTP sent to your email!");
        return true;
      } else {
        toast.warning("Login successful, but failed to send OTP.");
        return false;
      }
    } catch (error) {
      console.error("Send OTP error:", error);
      toast.warning("Login successful, but failed to send OTP.");
      return false;
    }
  };
